import { render, staticRenderFns } from "./Modale.vue?vue&type=template&id=61571023"
import script from "./Modale.vue?vue&type=script&lang=js"
export * from "./Modale.vue?vue&type=script&lang=js"
import style0 from "./Modale.vue?vue&type=style&index=0&id=61571023&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports